export default {"src":"/_next/static/media/stripeLogo.ddcf6bd5.svg","height":223,"width":468,"blurWidth":0,"blurHeight":0};